import { render, staticRenderFns } from "./expressrejection-list.vue?vue&type=template&id=2e9c2a8e&scoped=true&"
import script from "./expressrejection-list.vue?vue&type=script&lang=ts&"
export * from "./expressrejection-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9c2a8e",
  null
  
)

export default component.exports